import React from "react";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Checkbox from "@mui/material/Checkbox";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import OrderActions from "./OrderActions";
import { PlanData } from "types/models/planMaster/planMasterApp";

const COLUMN_WIDTHS: Record<string, number> = {
  action: 130,
  selection: 130,
  planName: 150,
  status: 130,
  planGroupCode: 150,
  rentExclTax: 130,
  planDuration: 150,
  popPlan: 130,
};

const StyledTableCell = styled(TableCell)<{ colId?: string }>(({ colId }) => ({
  fontSize: 14,
  padding: 8,
  textAlign: "left",
  width: colId ? COLUMN_WIDTHS[colId] : 130,
  minWidth: 120,
  maxWidth: 160,
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
}));

interface TableItemProps {
  data: PlanData;
  selected: boolean;
  onSelect: (planId: string) => void;
}

const TableItem: React.FC<TableItemProps> = ({ data, selected, onSelect }) => {
  const getStatusColor = () => {
    switch (data.status) {
      case "Active":
        return "#43C888";
      case "InActive":
        return "#F84E4E";
      default:
        return "#E2A72E";
    }
  };

  return (
    <TableRow hover>
      <StyledTableCell colId="action">
        <OrderActions data={data} />
      </StyledTableCell>

      <StyledTableCell colId="selection" padding="checkbox">
        <Checkbox
          checked={selected}
          onChange={() => onSelect(data.planId.toString())}
          color="primary"
        />
      </StyledTableCell>

      <StyledTableCell colId="planName">{data.planName}</StyledTableCell>

      <StyledTableCell colId="status">
        <Box
          sx={{
            color: getStatusColor(),
            backgroundColor: getStatusColor() + "44",
            px: 1,
            py: 0.5,
            borderRadius: 1,
            fontSize: 14,
            display: "inline-block",
          }}
        >
          {data.status}
        </Box>
      </StyledTableCell>

      <StyledTableCell colId="planGroupCode">{data.planGroupCode}</StyledTableCell>
      <StyledTableCell colId="rentExclTax">{data.rentExclTax}</StyledTableCell>
      <StyledTableCell colId="planDuration">{data.planDuration}</StyledTableCell>
      <StyledTableCell colId="popPlan">{data.popPlan}</StyledTableCell>
      <StyledTableCell colId="planDuration">{data.planClassification}</StyledTableCell>
      <StyledTableCell colId="popPlan">{data.deviceSecurity}</StyledTableCell>
    </TableRow>
  );
};

export default TableItem;
